export default __webpack_public_path__ + "static/media/rakhi14.94dd384c.jpeg";